import { Logger } from "@auvious/common";
export const log = new Logger("asset");
export default log;
